import { Modal } from "@/utils/bootstrap";
import SvgModalClose from "../../lib/SvgModalClose";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "../../lib/CustomButton";
import SvgErrIcon from "./SvgErrIcon";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  errors: string[];
  setErrors: (errors: string[]) => void;
  /** Graylog reference code, set only when the failure was actually logged. */
  errorRef?: string;
}
const NotFieldErrModal: React.FC<Props> = ({ errors, setErrors, errorRef }) => {
  const t = useTranslation();
  const onHide = () => setErrors([]);

  // Drop blanks so no call site can render an empty popup.
  const messages = errors.filter(
    (err): err is string => typeof err === "string" && err.trim().length > 0,
  );
  const shown = messages.length
    ? messages
    : [t.an_error_occurred_during_the_operation];

  return (
    <Modal
      centered
      backdrop="static"
      show={errors.length > 0}
      onHide={onHide}
      dialogClassName="messagebox-dialog"
      contentClassName="messagebox-cart-disabled"
    >
      <div className="messagebox-closeicon">
        <SvgModalClose onClick={onHide} />
      </div>
      <div className="messagebox-title">
        <SvgErrIcon />
        {t.sorry}
      </div>
      <div className="message-err w-100">
        {shown.length === 1 ? (
          <div className="text-center">{shown[0]}</div>
        ) : (
          <ul className="message-err-list">
            {shown.map((err, key) => (
              <li key={key}>{err}</li>
            ))}
          </ul>
        )}
        {!!errorRef && (
          <div className="message-err-ref text-center">
            {t.error_reference_code}:{" "}
            <bdi dir="ltr" className="message-err-ref-code">
              {errorRef}
            </bdi>
          </div>
        )}
      </div>
      <CustomButton
        type={BtnTypes.primary}
        size={BtnSizes.small}
        radius={BtnRadius.small}
        onClick={onHide}
      >
        {t.close}
      </CustomButton>
    </Modal>
  );
};

export default NotFieldErrModal;
